
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 2H15V4H21V6H3V4H9V2ZM7 20V7H5V22H19V7H17V20H7ZM9 9H11V18H9V9ZM15 9H13V18H15V9Z" fill="currentColor"></path></svg>';export default svg;
    